import { usePage } from "@inertiajs/react";
import classNames from "classnames";

import Checkbox from "/components/Checkbox";

import projectPreviewFallbackImage from "/assets/project-preview-fallback.jpg";
import styles from "./ProjectLinksForm.module.css";

export default function ProjectLinksForm({
  project_links,
  onChange,
}) {
  const { project_options, dictionaries } = usePage().props;
  const selectedProjectIds =
    project_links
      .filter(({ _destroy }) => !_destroy)
      .sort((pa, pb) => pa.order - pb.order)
      .map(({ project_id }) => project_id.toString());

  const syncLinksOrder = (projectLinks) =>
    projectLinks.map((projectLink, index) => ({ ...projectLink, order: index }));

  const toggleProjectLink = (target_project_id) => {
    const projectLinks = [...project_links];
    const projectLink = projectLinks.find(({ project_id }) => target_project_id == project_id);

    if (!projectLink) {
      projectLinks.push({ project_id: target_project_id });
      onChange(syncLinksOrder(projectLinks));
      return;
    }

    const newLinks = projectLinks.filter(({ project_id }) => project_id != target_project_id);
    if (projectLink.id)
      newLinks.push({ ...projectLink, _destroy: !projectLink._destroy })

    onChange(syncLinksOrder(newLinks));
  };

  return (
    <div className={styles.projectLinksForm}>
      <div className={styles.projectsList}>
        <span>Выбери какие кейсы нужно добавить в коллекцию</span>

        <table className={classNames("tbl", "tbl--bordered-head")}>
          <thead>
            <tr>
              <th></th>
              <th>Привью</th>
              <th>Название кейса</th>
              <th>{dictionaries.clients.name_ru}</th>
            </tr>
          </thead>

          <tbody>
            {Object.keys(project_options).map((id) => {
              const project = project_options[id];

              return (
                <tr key={id} onClick={() => toggleProjectLink(id)}>
                  <td><Checkbox value={selectedProjectIds.includes(id)} /></td>
                  <td className="tbl-preview"><img src={project.og_image_ru_url || projectPreviewFallbackImage} /></td>
                  <td>{project.ru}</td>
                  <td>{project.client_ru}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      <div className={styles.projectsList}>
        <span>Кейсы в коллекции</span>
        <table className={classNames("tbl", "tbl--bordered-head")}>
          <thead>
            <tr>
              <th>Привью</th>
              <th>Название кейса</th>
              <th>{dictionaries.clients.name_ru}</th>
            </tr>
          </thead>

          <tbody>
            {selectedProjectIds.map((project_id) => {
              const project = project_options[project_id];
              if (!project)
                return null;

              return (
                <tr key={project_id}>
                  <td className="tbl-preview"><img src={project.og_image_ru_url || projectPreviewFallbackImage} /></td>
                  <td>{project.ru}</td>
                  <td>{project.client_ru}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
